import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Truck, Settings } from 'lucide-react';
import { TenantDetails } from '@/types/tenant.types';

interface TenantDeliverySettingsProps {
  tenant: TenantDetails;
}

const deliveryModeLabels: Record<string, string> = {
  QuBox: 'Blue Basket',
  self: 'توصيل ذاتي',
  hybrid: 'مختلط',
};

export function TenantDeliverySettings({ tenant }: TenantDeliverySettingsProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Truck className="h-4 w-4" />
          إعدادات التوصيل
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">وضع التوصيل</span>
          <Badge variant="outline" className="bg-primary/10 text-primary border-primary/20">
            {deliveryModeLabels[tenant.delivery_mode] || tenant.delivery_mode}
          </Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">آخر تحديث</span>
          <span className="text-sm font-medium">
            {new Date(tenant.updated_at).toLocaleDateString('ar-EG')}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
